import { CSSObject } from '@chakra-ui/react';
import loader from '../../../../assets/questbet/images/loader.png';

export const SpinnerLoader: CSSObject = {
  bgImage: `url(${loader})`,
};
